module.exports = __webpack_public_path__ + "static/media/vertical02.1ccab843.png";